import {
  Box,
  makeStyles,
  InputLabel,
  FormControl,
  Select,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { backend } from "../../api";
import { PageBanner } from "../../components";
import { DropzoneArea } from "material-ui-dropzone";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { authorAddBook } from "../../redux-store/books/actions";
import { ADD_BOOK_RESET } from "../../redux-store/constants";
import BookTypes from "./BookTypes";
import { FaDownload } from "react-icons/fa";
import { getSize } from "../../utils";

const useStyles = makeStyles((theme) => ({
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  submitBtn: {
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
}));

function AddBookD2p() {
  const classes = useStyles();
  const [title, setTitle] = useState("");
  const [cover, setCover] = useState("");
  const [story, setStory] = useState("");
  const [checked, setChecked] = useState({
    hardcover: false,
    paperback: false,
  });
  const [category, setCategory] = useState({ category_name: "Biography" });
  const [pdfFile, setPdfFile] = useState("");
  const [coverFile, setCoverFile] = useState({});
  const [categories, setCategories] = useState([]);
  const [bookTypes, setBookTypes] = useState("");
  const [error, setError] = useState({ pdf_file: false });
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.auth);
  const { success } = useSelector((state) => state.addBook);
  const [digitalPrice, setDigitalPrice] = useState(1);

  const history = useHistory();
  let formData = new FormData();
  useEffect(() => {
    fetchCategory();
    if (success) {
      dispatch({ type: ADD_BOOK_RESET });
      history.replace(`/dashboard/${currentUser?.author?.role}`);
    }
    if (checked.hardcover == true && checked.paperback == true) {
      setBookTypes("all");
    } else if (checked.hardcover == false && checked.paperback == true) {
      setBookTypes("paperback");
    } else if (checked.hardcover == true && checked.paperback == false) {
      setBookTypes("hardcover");
    } else if (checked.hardcover == false && checked.paperback == false) {
      setBookTypes("");
    }
  }, [success, checked]);

  const fetchCategory = () => {
    backend
      .get(`/category?isActive=${true}`)
      .then((res) => {
        if (res.data.message === "Book Category Found Successfully") {
          setCategories(res.data.data);
          setCategory(res.data.data[0]);
        }
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
        toast.error(message);
      });
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (bookTypes !== "") {
      //user must upload hardcover or paperback for d2p publishing.
      const newBook = {
        book_title: title,
        book_category: category,
        book_story: story,
        book_cover: cover,
        cover_files: coverFile,
        author: currentUser.author._id,
        writer: currentUser._id,
        print_on_demand: "admin",
        pdf_file: pdfFile,
        bookTypes,
        price: {
          digital_price: digitalPrice,
        },
      };

      dispatch(authorAddBook(newBook));
    }
  };

  const handleChangeCategory = (e) => {
    setCategory({ ...category, category_name: e.target.value });
  };

  const uploadFileToS3 =  (role, file) => {
    formData = new FormData();
    formData.append("files", file);
    backend
      .post("/file/fileUpload", formData)
      .then(async (res) => {
        if (res.status === 200) {
          if (role === "cover") {
            setCover(res.data.locationArray[0].fileLocation);
          }
          if (role === "pdfBook") {
            let size = false;
            size = await getSize(res.data.locationArray[0].fileLocation);

            if (size == true) {
              setPdfFile(res.data.locationArray[0].fileLocation);
            } else {
              toast.error("This is incorrect size");
            }
          }
          if (role === "hardCover") {
            setCoverFile({
              ...coverFile,
              hard_cover: res.data.locationArray[0].fileLocation,
            });
          }
          if (role === "paperBackCover") {
            setCoverFile({
              ...coverFile,
              paper_back: res.data.locationArray[0].fileLocation,
            });
          }
        }
      })
      .catch((err) => {
        toast.error({ "Error in File Upload": err });
      });
  };

  const selectBookTypes = (e) => {
    setChecked({ ...checked, [e.target.name]: e.target.checked });
  };
  return (
    <Fragment>
      <Helmet>
        <title>Add Book d2p</title>
      </Helmet>
      <ToastContainer />
      <PageBanner
        image={"/assets/images/bg4.jpg"}
        title={"Add Book"}
        size="small"
        titleAlign="left"
      />
      <Box style={{ width: "80%", maxWidth: 600, margin: "50px auto" }}>
        <Typography variant="body2" color="error" style={{ marginBottom: 20 }}>
          * All Field are Necessary
        </Typography>
        {categories && (
          <form onSubmit={handleFormSubmit}>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Title</InputLabel>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  type="text"
                  className={classes.inputField}
                  name="title"
                  required
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </FormControl>
            </Box>

            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Book Types</InputLabel>
              <FormControl variant="outlined" fullWidth>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked.paperback}
                      onChange={selectBookTypes}
                      value="paperback"
                      name="paperback"
                      color="primary"
                    />
                  }
                  label="Paperback cover"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked.hardcover}
                      onChange={selectBookTypes}
                      value="hardcover"
                      name="hardcover"
                      color="primary"
                    />
                  }
                  label="Hard cover"
                />
                <>
                  <a href="https://c5m-assets.s3.amazonaws.com/lulu-book-creation-guide-1643800503143.pdf">
                    <FaDownload
                      color="#ffb203"
                      title="Click to download sample"
                      size={25}
                    ></FaDownload>
                  </a>
                  <Typography variant="body2" color="error">
                    You should download the book creation guide. You'll just
                    have to use our equation in the Book Creators Guide to
                    calculate the size of the cover and require that it has been
                    uploaded in that size. PDF cover size formatting must be
                    according to the guide to be approved.
                  </Typography>
                </>

                {bookTypes == "e-book" && (
                  <Typography variant="subtitle2" color="error">
                    Atleast one cover type needs to be selected.
                  </Typography>
                )}
              </FormControl>
            </Box>

            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Cover</InputLabel>
              <DropzoneArea
                onChange={(files) => uploadFileToS3("cover", files[0])}
                acceptedFiles={["image/*"]}
                // maxFileSize={3000000}
                filesLimit={1}
                name="img"
                id="cvr"
                inputProps={{
                  name: "img",
                  id: "cvr",
                  required: true,
                  style: { display: "inline-block", opacity: 0 },
                }}
                onDelete={() => setCover("")}
                dropzoneText="Upload Image for Book Cover"
                style={{ maxHeight: 100 }}
              />
            </Box>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Category</InputLabel>
              <FormControl variant="outlined" fullWidth>
                <Select
                  native
                  onChange={handleChangeCategory}
                  placeholder="Select Category"
                >
                  {categories.map((item) => (
                    <option value={item.category_name}>
                      {item.category_name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box mb={2}>
              <>
                <InputLabel className={classes.fieldLabel}>
                  BOOK INTERIOR PDF File
                </InputLabel>
                <DropzoneArea
                  onChange={(files) => {
                    if (files[0]) {
                      uploadFileToS3("pdfBook", files[0]);
                    }
                  }}
                  acceptedFiles={["application/pdf"]}
                  onDelete={() => setPdfFile("")}
                  name="book"
                  id="bookfile"
                  inputProps={{
                    name: "book",
                    id: "bookfile",
                    required: true,
                    style: { display: "inline-block", opacity: 0 },
                  }}
                  filesLimit={1}
                  dropzoneText="Upload PDF File of Book"
                  style={{ maxHeight: 100 }}
                />

                <Typography variant="body2" color="error">
                  For Executive size pdf width should be 7 and height must be
                  10. For US letter size pdf width must be 8.5 and height must
                  be 11. For a4 size pdf width must be between 8.26 & 8.28 and
                  height must be 11.69.
                </Typography>
              </>
            </Box>

            <BookTypes
              type={bookTypes}
              coverFiles={coverFile}
              setCoverFiles={setCoverFile}
              upload={uploadFileToS3}
            />
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>
                Digital Price
              </InputLabel>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  type="number"
                  required={true}
                  name="digital_price"
                  defaultValue={1}
                  className={classes.inputField}
                  onChange={(e) => setDigitalPrice(+e.target.value)}
                />
              </FormControl>
            </Box>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Story</InputLabel>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  required
                  type="text"
                  className={classes.inputField}
                  fullWidth
                  multiline
                  rows={8}
                  name="story"
                  value={story}
                  onChange={(e) => setStory(e.target.value)}
                />
              </FormControl>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Button
                className={classes.cancelBtn}
                onClick={() => history.goBack()}
              >
                Go Back
              </Button>
              <Button type="submit" className={classes.submitBtn}>
                Add
              </Button>
            </Box>
          </form>
        )}
      </Box>
    </Fragment>
  );
}
export default AddBookD2p;
